import axios from 'axios';
import {PrivacyPolicyAPIsConstants} from "../enums/PrivacyPolicy";

const PrivacyPolicyModule = {
  namespaced: true,
  state: {
    data: [],
    loadingItem: false,
    itemEditable: {},
  },
  mutations: {
    SET_LOADING_ITEM(state, payload) {
      state.loadingItem = payload;
    },
    SET_ITEM_EDITABLE(state, payload) {
      state.itemEditable = payload.itemEditable;
    }
  },
  actions: {
    updatePrivacyPolicy({ commit, state }, { credentials }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${PrivacyPolicyAPIsConstants.API_PATH}`, { policy_type: 'privacy', ...credentials })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getPrivacyPolicy({ commit, state }) {
      commit('SET_LOADING_ITEM', true);
      return new Promise((resolve, reject) => {
      axios
        .get(`${PrivacyPolicyAPIsConstants.GET_API_PATH}`)
        .then((res) => {
          commit('SET_LOADING_ITEM', false);
          commit('SET_ITEM_EDITABLE', {
            itemEditable: res.data.result?.policy_version,
          });
          resolve(res);
        })
        .catch((error) => {
          commit('SET_LOADING_ITEM', false);
          reject(error);
        });
      });
    },
  }
};
export default PrivacyPolicyModule;
